export const CalendarModelFields = {
    id: "id",
    title: "subject",
    body: "body",
    start: "start",
    end: "end"
};